import { gql } from '@apollo/client/core';
import React from 'react';
import { Image } from '..';
/**
 *
 * @param {{
 *  producer?: { logo: { url: string? }? }?;
 *  height: number;
 *  width: number;
 *  style?: import('@react-pdf/types').Style;
 *  [x: string]: any;
 * }} props
 * @returns
 */
export default function ProducerLogo({
  producer,
  height,
  width,
  style,
  ...rest
}) {
  if (!hasContent(producer)) return null;
  return (
    <Image
      src={producer?.logo?.url}
      style={style}
      height={height}
      width={width}
      trim
      {...rest}
    />
  );
}

ProducerLogo.hasContent = hasContent;

function hasContent(producer) {
  return !!producer?.logo?.url;
}

ProducerLogo.fragment = gql`
  fragment ProducerLogo on Producer {
    logo {
      url
    }
  }
`;
